import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "./ExperienceForm.css";
import { ThreeDot } from "react-loading-indicators";
import { Check } from "lucide-react"; 
const BASE_URL = process.env.REACT_APP_BASE_URL;
const InternshipForm = ({ onClose, onSave, defaultValues = {} }) => {
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const currentRole = watch("currently_working", false);

  const onSubmit = async (data) => {
    const token =
      localStorage.getItem("access_token") || localStorage.getItem("access");
    const skillsArray = data.skills
      ? data.skills.split(",").map((s) => s.trim())
      : [];
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("company", data.company);
    formData.append("currently_working", data.currently_working || false);
    formData.append("start_month", data.start_month);
    formData.append("start_year", data.start_year);
    if (!data.currently_working) {
      formData.append("end_month", data.end_month || "");
      formData.append("end_year", data.end_year || "");
    }
    formData.append("location", data.location || "");
    formData.append("location_type", data.location_type || "");
    formData.append("description", data.description || "");
    if (data.media && data.media.length > 0) {
      formData.append("media", data.media[0]);
    }
    skillsArray.forEach((skills) => {
      formData.append("skills", skillsArray.join(","));
    });
    if (defaultValues?.id) {
      formData.append("id", defaultValues.id);
    }
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/user/portfolio/internship/`, {
        method: defaultValues?.id ? "PATCH" : "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      });
      if (!res.ok) {
        const errorData = await res.json();
        console.error("API Error:", errorData);
        throw new Error("Failed to save internship");
      }
      const result = await res.json();
      onSave(result?.data || result);
      onClose();
    } catch (error) {
      console.error("Submission error:", error);
      alert("Failed to submit internship");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (defaultValues) {
      for (const key in defaultValues) {
        if (key === "skills" && Array.isArray(defaultValues.skills)) {
          setValue("skills", defaultValues.skills.join(", "));
        } else if (key !== "media") {
          setValue(key, defaultValues[key]);
        }
      }
    }
  }, [defaultValues, setValue]);

  return (
    // <div className="experience-form-container">
    //   <form onSubmit={handleSubmit(onSubmit)}>
    //     {/* Title */}
    //     <div className="experience-form-field">
    //       <label>
    //         Title<span style={{ color: "red" }}>*</span>
    //       </label>
    //       <input
    //         {...register("title", { required: true })}
    //         placeholder="Ex: Software Engineering Intern"
    //       />
    //       {errors.title && <p className="error">This field is required</p>}
    //     </div>

    //     {/* Company */}
    //     <div className="experience-form-field">
    //       <label>
    //         Company or Organization<span style={{ color: "red" }}>*</span>
    //       </label>
    //       <input
    //         {...register("company", { required: true })}
    //         placeholder="Ex: Google"
    //       />
    //       {errors.company && <p className="error">This field is required</p>}
    //     </div>

    //     {/* Current Role */}
    //     <div className="experience-form-field">
    //       <label>
    //         <input
    //           type="checkbox"
    //           {...register("currently_working")}
    //           style={{ marginRight: "8px" }}
    //         />
    //         I am currently working in this role
    //       </label>
    //     </div>

    //     {/* Start Date */}
    //     <div className="experience-form-row">
    //       <div className="experience-form-field">
    //         <label>
    //           Start Month<span style={{ color: "red" }}>*</span>
    //         </label>
    //         <select {...register("start_month", { required: true })}>
    //           <option value="">Month</option>
    //           {[
    //             "January",
    //             "February",
    //             "March",
    //             "April",
    //             "May",
    //             "June",
    //             "July",
    //             "August",
    //             "September",
    //             "October",
    //             "November",
    //             "December",
    //           ].map((month) => (
    //             <option key={month} value={month}>
    //               {month}
    //             </option>
    //           ))}
    //         </select>
    //         {errors.start_month && <p className="error">Required</p>}
    //       </div>
    //       <div className="experience-form-field">
    //         <label>
    //           Start Year<span style={{ color: "red" }}>*</span>
    //         </label>
    //         <input
    //           type="number"
    //           {...register("start_year", {
    //             required: "Start year is required",
    //             min: { value: 1900, message: "Year cannot be before 1900" },
    //             max: {
    //               value: new Date().getFullYear() + 5,
    //               message: "Year is too far in future",
    //             },
    //             validate: (value) =>
    //               /^\d{4}$/.test(value) || "Must be a 4-digit year",
    //           })}
    //           placeholder="Year"
    //         />
    //         {errors.start_year && (
    //           <p className="error">{errors.start_year.message}</p>
    //         )}{" "}
    //       </div>
    //     </div>

    //     {/* End Date */}
    //     {!currentRole && (
    //       <div className="experience-form-row">
    //         <div className="experience-form-field">
    //           <label>End Month</label>
    //           <select {...register("end_month")}>
    //             <option value="">Month</option>
    //             {[
    //               "January",
    //               "February",
    //               "March",
    //               "April",
    //               "May",
    //               "June",
    //               "July",
    //               "August",
    //               "September",
    //               "October",
    //               "November",
    //               "December",
    //             ].map((month) => (
    //               <option key={month} value={month}>
    //                 {month}
    //               </option>
    //             ))}
    //           </select>
    //         </div>
    //         <div className="experience-form-field">
    //           <label>End Year</label>
    //           <input
    //             type="number"
    //             {...register("end_year", {
    //               min: { value: 1900, message: "Year cannot be before 1900" },
    //               max: {
    //                 value: new Date().getFullYear() + 5,
    //                 message: "Year is too far in future",
    //               },
    //               validate: (value) => {
    //                 const startYear = watch("start_year");
    //                 return (
    //                   !value ||
    //                   parseInt(value) >= parseInt(startYear) ||
    //                   "End year must be after start year"
    //                 );
    //               },
    //             })}
    //             placeholder="Year"
    //           />
    //           {errors.end_year && (
    //             <p className="error">{errors.end_year.message}</p>
    //           )}
    //         </div>
    //       </div>
    //     )}

    //     {/* Location */}
    //     <div className="experience-form-field">
    //       <label>Location</label>
    //       <input {...register("location")} placeholder="Ex: Bengaluru, India" />
    //     </div>

    //     {/* Location Type */}
    //     <div className="experience-form-field">
    //       <label>Location Type</label>
    //       <select {...register("location_type")}>
    //         <option value="">Please select</option>
    //         <option value="Onsite">Onsite</option>
    //         <option value="Hybrid">Hybrid</option>
    //         <option value="Remote">Remote</option>
    //       </select>
    //     </div>

    //     {/* Skills */}
    //     <div className="experience-form-field">
    //       <label>Skills</label>
    //       <input
    //         {...register("skills")}
    //         placeholder="Comma separated skills (e.g., React, Node)"
    //       />
    //     </div>

    //     {/* Media */}
    //     <div className="experience-form-field">
    //       <label>Media</label>
    //       {defaultValues?.media && typeof defaultValues.media === "string" && (
    //         <div style={{ marginBottom: "8px" }}>
    //           <a
    //             href={defaultValues.media}
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={{ color: "#007bff", textDecoration: "underline" }}
    //           >
    //             View Uploaded Media
    //           </a>
    //           <p style={{ fontSize: "0.8rem", color: "gray" }}>
    //             Uploading a new file will replace the existing one.
    //           </p>
    //         </div>
    //       )}
    //       <input type="file" {...register("media")} />
    //     </div>

    //     {/* Description */}
    //     <div className="experience-form-field">
    //       <label>Description</label>
    //       <textarea
    //         {...register("description")}
    //         placeholder="Summarize your responsibilities or contributions"
    //         rows={3}
    //       />
    //     </div>

    //     {/* Actions */}
    //     <div className="experience-form-actions">
    //       {/* <button type="button" className="cancel-btn" onClick={onClose}>
    //         Cancel
    //       </button> */}
    //       <button
    //         type="submit"
    //         disabled={Object.keys(errors).length > 0}
    //         className="save-btn"
    //       >
    //         {loading ? <ThreeDot color={["#4A90E2"]} size="small" /> : "Save"}{" "}
    //       </button>
    //     </div>
    //   </form>
    // </div>
    <div className="p-2 w-full">
  <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
    {/* Title */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">
          Title <span className="text-red-500">*</span>
        </label>
      </div>
      <input
        {...register("title", { required: true })}
        placeholder="Software Engineering Intern, Research Assistant, etc."
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
      {errors.title && <p className="text-red-500 text-xs mt-2">This field is required</p>}
    </div>

    {/* Company */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">
          Company or Organization <span className="text-red-500">*</span>
        </label>
      </div>
      <input
        {...register("company", { required: true })}
        placeholder="Google, Microsoft, University of Cambridge, etc."
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
      {errors.company && <p className="text-red-500 text-xs mt-2">This field is required</p>}
    </div>

    {/* Current Role */}
  <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl cursor-pointer">
  <div className="relative">
    {/* Hidden checkbox */}
    <input 
      type="checkbox" 
      {...register("currently_working")}
      id="currently_working" 
      className="sr-only" 
    />
    {/* Custom box */}
    <div className="w-5 h-5 border-2 border-gray-300 rounded flex items-center justify-center">
      {/* Show Check icon if checked */}
      {watch("currently_working") && <Check className="w-4 h-4 text-[#0f6abf]" />}
    </div>
  </div>
  <label 
    htmlFor="currently_working" 
    className="text-sm text-gray-700 select-none"
  >
    I am currently working in this role
  </label>
</div>

    {/* Start Date */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">
          Start Date <span className="text-red-500">*</span>
        </label>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <select
          {...register("start_month", { required: true })}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 12px center'
          }}
        >
          <option value="">Month</option>
          {[
            "January","February","March","April","May","June",
            "July","August","September","October","November","December"
          ].map((month) => (
            <option key={month} value={month}>{month}</option>
          ))}
        </select>

        <input
          type="number"
          {...register("start_year", {
            required: "Start year is required",
            min: { value: 1900, message: "Year cannot be before 1900" },
            max: { value: new Date().getFullYear() + 5, message: "Year is too far in future" },
            validate: (value) => /^\d{4}$/.test(value) || "Must be a 4-digit year",
          })}
          placeholder="Year"
          className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        />
      </div>
      {errors.start_month && <p className="text-red-500 text-xs mt-2">Required</p>}
      {errors.start_year && <p className="text-red-500 text-xs mt-2">{errors.start_year.message}</p>}
    </div>

    {/* End Date */}
    {!currentRole && (
      <div>
        <div className="flex items-center gap-2 mb-3">
          
          <label className="text-sm font-semibold text-gray-700">End Date</label>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <select 
            {...register("end_month")} 
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center'
            }}
          >
            <option value="">Month</option>
            {[
              "January","February","March","April","May","June",
              "July","August","September","October","November","December"
            ].map((month) => (
              <option key={month} value={month}>{month}</option>
            ))}
          </select>
          
          <input
            type="number"
            {...register("end_year", {
              min: { value: 1900, message: "Year cannot be before 1900" },
              max: { value: new Date().getFullYear() + 5, message: "Year is too far in future" },
              validate: (value) => {
                const startYear = watch("start_year");
                return !value || parseInt(value) >= parseInt(startYear) || "End year must be after start year";
              },
            })}
            placeholder="Year"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>
        {errors.end_year && <p className="text-red-500 text-xs mt-2">{errors.end_year.message}</p>}
      </div>
    )}

    {/* Location */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">Location</label>
      </div>
      <input 
        {...register("location")} 
        placeholder="Bengaluru, India or Remote" 
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Location Type */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">Location Type</label>
      </div>
      <select 
        {...register("location_type")} 
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 12px center'
        }}
      >
        <option value="">Select location type</option>
        <option value="Onsite">Onsite</option>
        <option value="Hybrid">Hybrid</option>
        <option value="Remote">Remote</option>
      </select>
    </div>

    {/* Skills */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">Skills</label>
      </div>
      <input
        {...register("skills")}
        placeholder="React, Node.js, Python, Machine Learning, etc."
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Media */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">Media</label>
      </div>
      {defaultValues?.media && typeof defaultValues.media === "string" && (
        <div className="mb-3 p-3 bg-gray-50 rounded-xl">
          <a
            href={defaultValues.media}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0f6abf] hover:underline text-sm font-medium"
          >
            View Uploaded Media
          </a>
          <p className="text-xs text-gray-500 mt-1">Uploading a new file will replace the existing one.</p>
        </div>
      )}
      <input 
        type="file" 
        {...register("media")} 
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Description */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        
        <label className="text-sm font-semibold text-gray-700">Description</label>
      </div>
      <textarea
        {...register("description")}
        placeholder="Summarize your responsibilities, achievements, or contributions..."
        rows={4}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-none"
      />
    </div>

    {/* Actions */}
    <div className="pt-6 border-t border-gray-100">
      <button
        type="submit"
        disabled={Object.keys(errors).length > 0}
        className="w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Saving...
          </>
        ) : (
          <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Save Experience
          </>
        )}
      </button>
    </div>
  </form>
</div>
  );
};

export default InternshipForm;
